import React from 'react';
import { Toast } from 'react-bootstrap';
import { 
  FaCheckCircle, 
  FaExclamationTriangle, 
  FaInfoCircle, 
  FaTimesCircle,
  FaSpinner
} from 'react-icons/fa';
import { NOTIFICATION_TYPES } from '../../context/NotificationContext';

const ToastNotification = ({ notification, onClose }) => {
  const { id, title, message, type, timestamp } = notification;
  
  // Check if this is a processing notification (info type with processing in title)
  const isProcessing = type === NOTIFICATION_TYPES.INFO && title.toLowerCase().includes('processing');
  
  // Format the timestamp
  const formattedTime = new Date(timestamp).toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit'
  });
  
  // Get appropriate icon and background color based on notification type
  const getNotificationProps = () => {
    switch (type) {
      case NOTIFICATION_TYPES.SUCCESS:
        return {
          icon: <FaCheckCircle />,
          bg: 'success',
          textColor: 'white'
        };
      case NOTIFICATION_TYPES.ERROR:
        return {
          icon: <FaTimesCircle />,
          bg: 'danger',
          textColor: 'white'
        };
      case NOTIFICATION_TYPES.WARNING:
        return {
          icon: <FaExclamationTriangle />,
          bg: 'warning',
          textColor: 'dark'
        };
      case NOTIFICATION_TYPES.INFO:
      default:
        return {
          icon: isProcessing ? <FaSpinner className="fa-spin" /> : <FaInfoCircle />,
          bg: 'info',
          textColor: 'white'
        };
    }
  };
  
  const { icon, bg, textColor } = getNotificationProps();
  
  return (
    <Toast 
      onClose={() => onClose(id)} 
      className={`notification-toast ${isProcessing ? 'processing-toast' : ''}`}
      animation={true}
      // Processing toasts don't auto-hide, but they should still be manually removable
      autohide={!isProcessing}
    >
      <Toast.Header className={`bg-${bg} text-${textColor}`}>
        <span className="me-2">{icon}</span>
        <strong className="me-auto">{title}</strong>
        <small>{formattedTime}</small>
      </Toast.Header>
      <Toast.Body>{message}</Toast.Body>
    </Toast>
  );
};

export default ToastNotification; 